import React, { Component } from 'react';
import PropTypes from "prop-types";
import moment from 'moment-timezone';
import Router from 'next/router';
import { parseCookies } from 'nookies';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Layout, Header, Footer, HotelLayout } from "../components";
import { axiosInstance, slugify } from '../utils';
import { rehydrateStore, setUpProduct, updateProduct, setUpHotel, onProductPagePageOpen } from '../redux/actions';

const mapStateToProps = state => ({
  date: state.userPreferences.date,
  guests: state.userPreferences.guests,
  product: state.userProduct.product,
  hotel: state.userProduct.hotel,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleProductUpdate: updateProduct,
  onPageOpen: onProductPagePageOpen,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class ProductPage extends Component {
  static propTypes = {
    hotelPhotos: PropTypes.instanceOf(Array),
    product: PropTypes.instanceOf(Object),
    name: PropTypes.string,
    onPageOpen: PropTypes.func,
    marketName: PropTypes.string,
    url: PropTypes.string,
    canonicalUrl: PropTypes.string,
    address: PropTypes.instanceOf(Object),
  };

  static async getInitialProps(ctx) {
    const { query, req, res, reduxStore } = ctx;

    try {
      let host;
      let referer;

      if (parseCookies(ctx).referer) {
        const baseUrl = '/search?';
        const splitUrl = parseCookies(ctx).referer.split('?')[1];
        referer = baseUrl.concat(splitUrl);
      } else {
        referer = `/search?product=Day%20Pass&market=Los%20Angeles%2CCA&date=${moment().format('YYYY-MM-DD')}&guests=2&priceHi=300&priceLo=0&distanceHi=0&distanceLo=0&sortType=2&experience=Festive%2CFamily%2CTranquil`;
      }

      let cookie;

      if (req) {
        host = req.headers.host;
        cookie = `sid=${parseCookies(ctx).sid};`;

        const { date } = query;
        const userPreferencesFromCookie = parseCookies(ctx)['user-preferences'] || '{}';
        let parsedUserPreferences = JSON.parse(userPreferencesFromCookie);

        if (date) {
          parsedUserPreferences = {
            ...JSON.parse(userPreferencesFromCookie),
            date,
          };
        }

        reduxStore.dispatch(rehydrateStore(parsedUserPreferences));
      } else {
        host = window.location.host;
      }

      const { data: hotelData } = await axiosInstance.get(`hotels/hotel/${query.pid}`, req && {
        headers: {
          Cookie: cookie,
        },
      });

      const selectedProduct = hotelData.products.find(availableProduct => availableProduct.id === Number(query.pid));
      const finalSelectedProduct = typeof selectedProduct !== 'undefined' ? selectedProduct : hotelData.products[0];
      const { name, id: productId, type, index, maxGuests, isKidAllow, meta, image, description } = finalSelectedProduct;

      const normalizedProduct = {
        index,
        name,
        id: productId,
        type,
        maxGuests,
        isKidAllow,
        meta,
        image,
        description,
      };
      let allAmenities = [];

      if (hotelData.amenities) {
        allAmenities = [...hotelData.amenities];

        const otherAmenityIndex = allAmenities.findIndex(amenity => amenity.type === '4');
        const otherAmenity = allAmenities.splice(otherAmenityIndex, 1);
        allAmenities.push(...otherAmenity);
      }

      const withSortedAmenities = {
        ...query,
        ...hotelData,
        amenities: allAmenities,
        referer,
      };

      const { name: hotelName, hotelType, address, reviews, rating, products, finePrint, marketName, marketId, hotelId, checkIn, recommendation } = hotelData;

      const normalizedHotel = {
        market: marketName,
        marketId,
        hotelId,
        checkIn,
        name: hotelName,
        hotelType,
        address,
        recommendation,
        city: address.city,
        reviews: Number(reviews.total) || 0,
        rating,
        products,
        finePrint,
      };

      reduxStore.dispatch(setUpHotel({ hotel: normalizedHotel }));
      reduxStore.dispatch(setUpProduct({ product: normalizedProduct }));

      const url = `https://${host}/l/${query.marketName}/${query.hotelName}?pid=${query.pid}${query.hid ? `&hid=${query.hid}` : ''}${query.date ? `&date=${query.date}` : ''}`;
      const canonicalUrl = `https://${host}/l/${query.marketName}/${query.hotelName}`;
      return { ...withSortedAmenities, url, canonicalUrl };
    } catch (error) {
      const { userPreferences } = reduxStore.getState();
      if (res) {
        res.writeHead(301, { Location: `/s/${slugify(userPreferences.city.market)}/day-passes` });
        res.end();
      } else {
        Router.push(`/s/${slugify(userPreferences.city.market)}/day-passes`);
      }
    }
  }

  componentDidMount() {
    const { onPageOpen } = this.props;

    onPageOpen();
  }

  render() {
    const { hotelPhotos, name, product: { meta }, marketName, url, canonicalUrl, address } = this.props;
    return (
      <Layout
        heading={`${name} | Dayaxe.com`}
        description={meta.description || `
          Book a day pass, cabana or spa pass at the ${name} hotel for as low as $20/guest.
          See what you get, photos, amenities and events of this luxurious ${marketName} hotel.
          Read reviews, compare prices and book your all day VIP access today!
        `}
        metaKeywords={meta.keywords}
        image={hotelPhotos && `${process.env.CDN_URL}${hotelPhotos[0]}`}
        url={url}
        canonical={canonicalUrl}
        type="product"
      >
        <Header isInnerPage fixed />
        {address && (
          <span style={{ display: 'none' }}>
            <ul itemScope itemType="http://schema.org/BreadcrumbList">
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                <span itemProp="name">United States</span>
                <meta itemProp="position" content="1" />
              </li>
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                <span itemProp="name">{address.state}</span>
                <meta itemProp="position" content="2" />
              </li>
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                <span itemProp="name">{marketName}</span>
                <meta itemProp="position" content="3" />
              </li>
            </ul>
          </span>
        )}
        <HotelLayout {...this.props} />
        <Footer isInnerPage />
      </Layout>
    );
  }
}

export default ProductPage;
